import { StringUtils } from "../../../../../../Global/Base/Utils/StringUtils";
import { Localization } from "../../../../../../OW.Remoting/Remoting/Localization";
import { Control } from "../../../../../UI.BaseControls/Control";
import { GenericControl } from "../../../../../UI.BaseControls/GenericControl";
import { EventHelper } from "../../../../../UI.BaseControls/Helpers/EventHelper";
import { DropDownButtonItem } from "../../../../../UI.Controls/DropDownMenu/DropDownButtonItem";
import { IDropDownMenuItem } from "../../../../../UI.Controls/DropDownMenu/DropDownInterfaces";
import { DropDownMenu } from "../../../../../UI.Controls/DropDownMenu/DropDownMenu";
import { SeparatorMenuItem } from "../../../../../UI.Controls/DropDownMenu/SeparatorItem";
import { createElement, registerCustomElement } from "../../../../../UI.ElementarControls/Utils/CustomElementUtils";
import { DropDownMenuCheckboxItem } from "../DropDownMenuItems/DropDownMenuCheckboxItem";
import { IFilterUserValue } from "../FilterInterfaces";

export class BaseAdvancedFilters extends Control implements IFilterUserValue {
    protected _chbitems: Array<IDropDownMenuItem>;
    protected _menu: DropDownMenu;

    public get menu(): DropDownMenu {
        return this._menu;
    }

    protected _appendValueSection: HTMLElement;
    protected _selectedItems: Array<{ id: string; captionHTML: string; item: DropDownMenuCheckboxItem }>;

    public get items(): Array<IDropDownMenuItem> {
        return this._chbitems;
    }

    public get value(): any {
        const v = [];
        for (const val of this.items) {
            const v2 = val as DropDownMenuCheckboxItem;
            if (v2.isChecked)
                v.push(v2.value);
        }

        return v.join(", ");
    }

    public set value(v: any) {
        const val = v.split(", ");
        this.unselectedAll();
        for (const z of val) {
            this.selectItemByValue(z);
        }
    }

    public get userValue(): any {
        const v = [];
        for (const val of this.items) {
            const v2 = val as DropDownMenuCheckboxItem;
            if (v2.isChecked)
                v.push(v2.innerText);
        }

        return v.join(", ");
    }

    public set userValue(values: any) {
        if (!values) {
            return;
        }

        this._setUserValue(values);
    }

    public addItems(items: Array<{ id: string; value: any; valueType: string; lockey: string; captionHtml?: string; isChecked?: boolean }>): void {
        for (const item of items) {
            if (item == undefined) {
                this._chbitems.push(new SeparatorMenuItem());
                continue;
            }
            const m = new DropDownMenuCheckboxItem();
            if (item.captionHtml)
                m.setCaption(item.captionHtml);
            else {
                m.setLocalizedCaption(item.lockey);
                m.locKey = item.lockey;
            }
            m.isChecked = item.isChecked || false;
            m.value = item.value;
            m.valueType = item.valueType;
            m.valueId = item.id;

            this._chbitems.push(m);
            this._menu.addItem(m);
        }

        const m = new DropDownButtonItem();
        m.addItem("GUI-1", async (e) => { // OK
            EventHelper.stopImmediatePropagation(e);
            this._selectedItems = [];
            for (const item of this._chbitems) {
                if (item instanceof DropDownMenuCheckboxItem && item.isChecked) {
                    this._selectedItems.push({ id: item.valueId, captionHTML: await item.getCaption(), item: item });
                }
            }

            this._appendSelectedValue();

            m.parent.close();
        });

        m.addItem("GUI-2", (e) => { // Cancel
            EventHelper.stopImmediatePropagation(e);
            for (const item of this._chbitems) {
                if (item instanceof DropDownMenuCheckboxItem) {
                    item.isChecked = false;
                }
            }

            for (const si of this._selectedItems) {
                si.item.isChecked = true;
            }

            this._appendSelectedValue();
            m.parent.close();
        });

        this._menu.addItem(m);
    }

    public unselectedAll(): void {
        this._selectedItems = [];

        for (const item of this._chbitems) {
            if (item instanceof DropDownMenuCheckboxItem) {
                item.isChecked = false;
            }
        }

        this._appendValueSection.innerHTML = "";
    }

    public async selectItemByValue(val: any): Promise<void> {
        for (const item of this._chbitems) {
            if (item instanceof DropDownMenuCheckboxItem) {
                if (item.value == val) {
                    item.isChecked = true;
                    if (this._selectedItems.find(it => it.id == (item as DropDownMenuCheckboxItem).valueId) == null)
                        this._selectedItems.push({ id: item.valueId, captionHTML: await item.getCaption(), item: item });
                    break;
                }
            }
        }

        this._appendSelectedValue();
    }

    private _appendSelectedValue(): void {
        this._appendValueSection.innerHTML = "";
        const f_createElement = (item: { id: string; captionHTML: string; item: DropDownMenuCheckboxItem }) => {
            const oneitem = createElement({
                html: `<span>${StringUtils.stringToHTMLText(item.captionHTML)}</span>`,
                classes: "FilterValue",
                attrs: { //`
                    "data-filter-id": item.id,
                },
            });

            // pokud je caption prazdny a polozka ma nactene lokalizace
            if (StringUtils.isNullOrEmpty(item.captionHTML) && item.item.locKey) {
                Localization.addLocData(oneitem, item.item.locKey);
            }

            const removeElement = createElement({ classes: "Icon Remove" });

            GenericControl.registerEventListener(removeElement, "click", () => {
                item.item.isChecked = false;
                let i = 0;
                for (const sv of this._selectedItems) {
                    if (sv.item == item.item)
                        break;
                    i++;
                }
                this._selectedItems.splice(i, 1);
                oneitem.remove();
            });

            oneitem.appendChild(removeElement);

            return oneitem;
        };
        for (const sv of this._selectedItems) {
            this._appendValueSection.appendChild(f_createElement(sv));
        }
    }

    /**
     * Zpracuje uživatelský vstup do hodnoty komponenty
     * @param values Uživatelský vstup
     */
    protected async _setUserValue(values: any): Promise<void> {
        const userValues = values.split(", ");
        const valueList = [];

        for (const item of this._chbitems) {
            if (item instanceof DropDownMenuCheckboxItem) {
                const caption = await item.getCaption();

                if (userValues.includes(caption)) {
                    valueList.push(item.value);
                }
            }
        }

        this.value = valueList.join(", ");
    }

    protected override _constructor(): void {
        super._constructor();

        this._selectedItems = [];
        this._chbitems = [];
        const btnSection = createElement({ classes: "BtnSection" });
        const icon = createElement({ classes: "icon doc-list FilterMultiItem" });
        const arrow = createElement({ classes: "icon ui-arrow-bottom ArrowDown" });
        this._appendValueSection = createElement({ classes: "AppendValueSection" });

        btnSection.appendChild(icon);
        btnSection.appendChild(arrow);

        this.appendChild(btnSection);
        this.appendChild(this._appendValueSection);

        this._menu = new DropDownMenu();

        this._menu.addEventListener("open", () => {
            for (const item of this._chbitems) {
                if (item instanceof DropDownMenuCheckboxItem) {
                    item.isChecked = false;
                }
            }

            for (const si of this._selectedItems) {
                si.item.isChecked = true;
            }
        });

        btnSection.addEventListener("click", (e) => {
            this._menu.show(btnSection, e);
        });
    }
}

registerCustomElement("tsc-BaseAdvancedFilters", BaseAdvancedFilters);
